import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

function destinoTrasLoginAutenticado(router: Router): ReturnType<CanActivateFn> {
  const returnUrl = router.parseUrl(router.url).queryParams['returnUrl'];
  if (typeof returnUrl === 'string' && returnUrl.startsWith('/') && !returnUrl.startsWith('//')) {
    return router.parseUrl(returnUrl);
  }
  return router.createUrlTree(['/app']);
}

/**
 * Pantalla de login solo si no hay sesión y la instalación inicial ya no es obligatoria.
 * Si `setupRequired`, redirige a `/setup`.
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  auth.syncFromStorage();

  if (auth.isAuthenticated()) {
    return destinoTrasLoginAutenticado(router);
  }

  return auth.fetchSetupRequired().pipe(
    map((r) => (r.setupRequired ? router.createUrlTree(['/setup']) : true)),
    catchError(() => of(true)),
  );
};
